<app-message-header></app-message-header>


<div class="mat-elevation-z8">
    <mat-form-field appearance="outline" [floatLabel]="'never'">     
        <input matInput (keyup)="applyFilter($event.target.value)" matInput placeholder="Search" [(ngModel)]="search" >
        <mat-icon matPrefix>search</mat-icon>
    </mat-form-field>
</div>


<div class="table-container">
    <div style="padding-top: 3px;overflow-x: scroll;">
       <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" style="width: 150%;">
        <ng-container matColumnDef="reseller">
            <th id = "appl" mat-header-cell *matHeaderCellDef style="cursor: context-menu;"> Reseller Name</th>
            <td mat-cell *matCellDef="let element">
                <div class="textOverflow"> {{element.company}}
                </div>
            </td>
        </ng-container>

        <ng-container matColumnDef="application">
            <th id = "appl" mat-header-cell *matHeaderCellDef style="cursor: context-menu;"> Application Name</th>
            <td mat-cell *matCellDef="let element">
                <div class="textOverflow"> {{element.applicationName}}
                </div>
            </td>
        </ng-container>

        <ng-container matColumnDef="activeusers">
            <th id = "appl" mat-header-cell *matHeaderCellDef style="cursor: context-menu;" [hidden] = "isHidden"> {{formattedMonth1}} {{year20}} </th>
            <td id="widthSize" mat-cell *matCellDef="let element" [hidden] = "isHidden">
                
                        <div *ngIf="element.count !=='' && element.count !== null && element.count !== undefined">
                            {{element.count}}
                        </div>
                        <img *ngIf="element.count ==='' || element.count === null || element.count === undefined" src="assets/images/uib-loading-500x500.gif" alt="Count today's message Loader" width="25px" style="margin-top: 10px;">
              
            </td>
        </ng-container>
        
        <ng-container matColumnDef="previousmonth1">
            <th id = "appl" mat-header-cell *matHeaderCellDef style="cursor: context-menu;" [hidden] = "isHidden1"> {{formattedMonth2}} {{year21}}</th>
            <td mat-cell *matCellDef="let element" [hidden] = "isHidden1">
                 
                        <div *ngIf="element.count1 !=='' && element.count1 !== null && element.count1 !== undefined">
                            {{element.count1}}
                        </div>
                        <img *ngIf="element.count1 ==='' || element.count1 === null || element.count1 === undefined" src="assets/images/uib-loading-500x500.gif" alt="Count today's message Loader" width="25px" style="margin-top: 10px;">
              
           
            </td>
        </ng-container>


        <ng-container matColumnDef="previousmonth2">
            <th id = "appl" mat-header-cell *matHeaderCellDef style="cursor: context-menu;" [hidden] = "isHidden2"> {{formattedMonth3}} {{year22}}</th>
            <td mat-cell *matCellDef="let element" [hidden] = "isHidden2">
               
                        <div *ngIf="element.count2 !=='' && element.count2 !== null && element.count2 !== undefined">
                            {{element.count2}}
                        </div>
                        <img *ngIf="element.count2 ==='' || element.count2 === null || element.count2 === undefined" src="assets/images/uib-loading-500x500.gif" alt="Count today's message Loader" width="25px" style="margin-top: 10px;">
            
            </td>
        </ng-container>


        <ng-container matColumnDef="previousmonth3">
            <th id = "appl" mat-header-cell *matHeaderCellDef style="cursor: context-menu;" [hidden] = "isHidden3"> {{formattedMonth4}} {{year23}}</th>
            <td mat-cell *matCellDef="let element" [hidden] = "isHidden3">
                 
                        <div *ngIf="element.count3 !=='' && element.count3 !== null && element.count3 !== undefined">
                            {{element.count3}}
                        </div>
                        <img *ngIf="element.count3 ==='' || element.count3 === null || element.count3 === undefined" src="assets/images/uib-loading-500x500.gif" alt="Count today's message Loader" width="25px" style="margin-top: 10px;">
            
            </td>
        </ng-container>

        <ng-container matColumnDef="previousmonth4">
            <th id = "appl" mat-header-cell *matHeaderCellDef style="cursor: context-menu;" [hidden] = "isHidden4"> {{formattedMonth5}} {{year24}}</th>
            <td mat-cell *matCellDef="let element" [hidden] = "isHidden4">
               
                        <div *ngIf="element.count4 !=='' && element.count4 !== null && element.count4 !== undefined">
                            {{element.count4}}
                        </div>
                        <img *ngIf="element.count4 ==='' || element.count4 === null || element.count4 === undefined" src="assets/images/uib-loading-500x500.gif" alt="Count today's message Loader" width="25px" style="margin-top: 10px;">
            
           
            </td>
        </ng-container>

        <ng-container matColumnDef="previousmonth5">
            <th id = "appl" mat-header-cell *matHeaderCellDef style="cursor: context-menu;" [hidden] = "isHidden5"> {{formattedMonth6}} {{year26}}</th>
            <td mat-cell *matCellDef="let element" [hidden] = "isHidden5">
               
                        <div *ngIf="element.count5 !=='' && element.count5 !== null && element.count5 !== undefined">
                            {{element.count5}}
                        </div>
                        <img *ngIf="element.count5 ==='' || element.count5 === null || element.count5 === undefined" src="assets/images/uib-loading-500x500.gif" alt="Count today's message Loader" width="25px" style="margin-top: 10px;">
               
           
            </td>
        </ng-container>

        <ng-container matColumnDef="previousmonth6">
            <th id = "appl" mat-header-cell *matHeaderCellDef style="cursor: context-menu;" [hidden] = "isHidden6"> {{formattedMonth7}} {{year27}}</th>
            <td mat-cell *matCellDef="let element" [hidden] = "isHidden6">
               
                        <div *ngIf="element.count6 !=='' && element.count6 !== null && element.count6 !== undefined">
                            {{element.count6}}
                        </div>
                        <img *ngIf="element.count6 ==='' || element.count6 === null || element.count6 === undefined" src="assets/images/uib-loading-500x500.gif" alt="Count today's message Loader" width="25px" style="margin-top: 10px;">
              
            
            </td>
        </ng-container>

        <ng-container matColumnDef="previousmonth7">
            <th id = "appl" mat-header-cell *matHeaderCellDef style="cursor: context-menu;" [hidden] = "isHidden7"> {{formattedMonth8}} {{year28}}</th>
            <td mat-cell *matCellDef="let element" [hidden] = "isHidden7">
                
                        <div *ngIf="element.count7 !=='' && element.count7 !== null && element.count7 !== undefined">
                            {{element.count7}}
                        </div> 
                        <img *ngIf="element.count7 ==='' || element.count7 === null || element.count7 === undefined" src="assets/images/uib-loading-500x500.gif" alt="Count today's message Loader" width="25px" style="margin-top: 10px;">
           
            </td>
        </ng-container>

      

        <ng-container matColumnDef="previousmonth9">
            <th id = "appl" mat-header-cell *matHeaderCellDef style="cursor: context-menu;" [hidden] = "isHidden9"> {{formattedMonth9}} {{year30}}</th>
            <td mat-cell *matCellDef="let element" [hidden] = "isHidden9">
               
                        <div *ngIf="element.count9 !=='' && element.count9 !== null && element.count9 !== undefined">
                            {{element.count9}}
                        </div>
                        <img *ngIf="element.count9 ==='' || element.count9 === null || element.count9 === undefined" src="assets/images/uib-loading-500x500.gif" alt="Count today's message Loader" width="25px" style="margin-top: 10px;">
              
            
            </td>
        </ng-container>

        <ng-container matColumnDef="previousmonth10">
            <th id = "appl" mat-header-cell *matHeaderCellDef style="cursor: context-menu;" [hidden] = "isHidden10"> {{formattedMonth10}} {{year31}}</th>
            <td mat-cell *matCellDef="let element" [hidden] = "isHidden10">
                
                        <div *ngIf="element.count10 !=='' && element.count10 !== null && element.count10 !== undefined">
                            {{element.count10}}
                        </div>
                        <img *ngIf="element.count10 ==='' || element.count10 === null || element.count10 === undefined" src="assets/images/uib-loading-500x500.gif" alt="Count today's message Loader" width="25px" style="margin-top: 10px;">
          
            </td>
        </ng-container>


        <ng-container matColumnDef="previousmonth11">
            <th id = "appl" mat-header-cell *matHeaderCellDef style="cursor: context-menu;" [hidden] = "isHidden11"> {{formattedMonth11}} {{year32}}</th>
            <td mat-cell *matCellDef="let element" [hidden] = "isHidden11">
                
                        <div *ngIf="element.count11 !=='' && element.count11 !== null && element.count11 !== undefined">
                            {{element.count11}}
                        </div>
                        <img *ngIf="element.count11 ==='' || element.count11 === null || element.count11 === undefined" src="assets/images/uib-loading-500x500.gif" alt="Count today's message Loader" width="25px" style="margin-top: 10px;">
            
            </td>
        </ng-container>


        <ng-container matColumnDef="previousmonth12">
            <th id = "appl" mat-header-cell *matHeaderCellDef style="cursor: context-menu;" [hidden] = "isHidden12"> {{formattedMonth14}} {{year33}}</th>
            <td mat-cell *matCellDef="let element" [hidden] = "isHidden12">
               
                        <div *ngIf="element.count12 !=='' && element.count12 !== null && element.count12 !== undefined">
                            {{element.count12}}
                        </div>
                        <img *ngIf="element.count12 ==='' || element.count12 === null || element.count12 === undefined" src="assets/images/uib-loading-500x500.gif" alt="Count today's message Loader" width="25px" style="margin-top: 10px;">
          
            </td>
        </ng-container>

        <ng-container matColumnDef="previousmonth13">
            <th id = "appl" mat-header-cell *matHeaderCellDef style="cursor: context-menu;" [hidden] = "isHidden13"> {{formattedMonth13}} {{year34}}</th>
            <td mat-cell *matCellDef="let element" [hidden] = "isHidden13">
                
                        <div *ngIf="element.count13 !=='' && element.count13 !== null && element.count13 !== undefined">
                            {{element.count13}}
                        </div>
                        <img *ngIf="element.count13 ==='' || element.count13 === null || element.count13 === undefined" src="assets/images/uib-loading-500x500.gif" alt="Count today's message Loader" width="25px" style="margin-top: 10px;">
          
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns;"></tr>     
        <tr mat-row style="cursor: context-menu;" *matRowDef="let row; columns: displayedColumns;"></tr>   
    </table>
</div>
    <img  *ngIf="pageLoader" src="assets/images/uib-loading-500x500.gif"  alt="Page Loader" class="imageLoader" />

    
  <div *ngIf="(paginationCount>5); then thenBlock else elseBlock" ></div>
  <ng-template #thenBlock>  <app-pagination [collectionSize]="paginationCount" [pageSize]="10" [(page)]="page" [maxSize]="3" [disabled]="paginationDisabled" (pageChange)="pageChanged2($event)"></app-pagination></ng-template>
  <ng-template #elseBlock>
      <div *ngIf="(paginationCount<5); then tblock "></div>
  </ng-template>
  <ng-template #tblock></ng-template>
    
</div>
